import React, { useContext } from "react";

import { Preview } from "@creatomate/preview";
import { Dropdown, Icon } from "@culturehq/components";

import { Trans } from "app/utils";
import { CreatomateContext } from "../../../../../contexts/VideoStudioContext";
import BurnOption from "./BurnOption";
import LanguageSelector from "./LanguageSelector";
import TranslationOption from "./TranslationOption";
import DownloadOption from "./DownloadOption";
import DeleteOption from "./DeleteOption";

interface OptionsDropdownProps {
  availableLanguages: string[];
  activeLanguageCode?: string;
  changingLanguage: boolean;
  onLanguageChange: (language: string) => void;
  onSelectTranslation: (value: boolean) => void;
  preview: Preview;
}

const OptionsDropdown: React.FC<OptionsDropdownProps> = ({
  availableLanguages,
  activeLanguageCode,
  changingLanguage,
  onLanguageChange,
  onSelectTranslation,
  preview
}) => {
  const { data: { burnSubtitles, pendingSubtitle } } = useContext(CreatomateContext);

  const handleDropdownSelection = (value: string) => {
    switch (value) {
      case "add_translation":
        onSelectTranslation(true);
        break;
      default:
        break;
    }
  };

  return (
    <Dropdown className="Dropdown-Option-Sub" onChange={handleDropdownSelection} selected={null}>
      <Dropdown.Button className="Option-Subtitles-btn" disabled={!!pendingSubtitle}>
        <Icon icon="gear-b" />
        <span className="DownloadDp-Text"><Trans>Options</Trans></span>
      </Dropdown.Button>
      <Dropdown.ListBox className="DownloadDp-Options">
        <BurnOption
          activeLanguageCode={activeLanguageCode}
          preview={preview}
        />
        {burnSubtitles && (
          <LanguageSelector
            availableLanguages={availableLanguages}
            activeLanguageCode={activeLanguageCode}
            changingLanguage={changingLanguage}
            onLanguageChange={onLanguageChange}
          />
        )}
        <TranslationOption onSelectTranslation={onSelectTranslation} />
        <DownloadOption preview={preview} />
        <DeleteOption
          availableLanguages={availableLanguages}
          activeLanguageCode={activeLanguageCode}
          onLanguageChange={onLanguageChange}
          preview={preview}
        />
      </Dropdown.ListBox>
    </Dropdown>
  );
};

export default OptionsDropdown;
